var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.src != '')?_c('audio',{attrs:{"src":_vm.src,"autoplay":"","controls":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }